import React, { useState, useRef } from 'react';
import { Image, Typography } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

const { Text } = Typography;

interface ImageUploaderProps {
  onFileSelect: (file: File, previewUrl: string) => void;
  previewUrl: string | null;
}

/**
 * 图片上传组件
 * 支持点击选择文件和拖拽上传
 */
const ImageUploader: React.FC<ImageUploaderProps> = ({ onFileSelect, previewUrl }) => {
  const [isDragOver, setIsDragOver] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragOver(false);
  };

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragOver(false);

    const file = e.dataTransfer.files[0];
    if (file && file.type.startsWith('image/')) {
      processFile(file);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      processFile(file);
    }
  };

  const processFile = (file: File) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      onFileSelect(file, reader.result as string);
    };
    reader.readAsDataURL(file);
  };

  const handleClick = () => {
    inputRef.current?.click();
  };

  return (
    <div className="uploader-wrap">
      <div
        className={`upload-area ${isDragOver ? 'upload-area-drag' : ''}`}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        onClick={handleClick}
        style={{ width: '100%' }}
      >
        {previewUrl ? (
          <div className="upload-preview">
            <Image
              src={previewUrl}
              alt="已上传的户型图预览"
              className="upload-preview-image"
              preview={false}
            />
            <Text className="upload-change-text">点击或拖拽可更换图片</Text>
          </div>
        ) : (
          <div className="upload-empty">
            <span className="upload-icon">
              <UploadOutlined />
            </span>
            <Text className="upload-title">点击或拖拽上传户型图</Text>
            <Text type="secondary" className="upload-hint">
              支持 JPG、PNG、GIF、WebP 格式
            </Text>
          </div>
        )}
      </div>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        onChange={handleInputChange}
        style={{ display: 'none' }}
      />
    </div>
  );
};

export default ImageUploader;
